import {Component, OnInit} from '@angular/core';
import {MatButton, MatButtonModule, MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {Router, RouterLink} from '@angular/router';
import {MatTooltipModule} from '@angular/material/tooltip';
import {AuthenticationService} from '../../../../domain/services/auth/authentication.service';

@Component({
  selector: 'app-profile-menu',
  standalone: true,
  imports: [
    MatButton,
    MatIcon,
    MatIconButton,
    MatButtonModule,
    MatMenuModule,
    RouterLink,
    MatTooltipModule
  ],
  templateUrl: './profile-menu.component.html',
  styleUrl: './profile-menu.component.css'
})
export class ProfileMenuComponent implements OnInit {
  username: string = '';

  constructor(private readonly router: Router, private readonly auth: AuthenticationService) {
  }

  ngOnInit(): void {
    const currentUser = this.auth.getCurrentUser();
    this.username = currentUser?.username ?  currentUser?.username.replaceAll("\"","") : '';
  }

  logout() {
    this.auth.logout()
    this.redirectToLogin();
  }

  redirectToLogin(): void {
    this.router.navigate(['/login']);
  }
}
